import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { useEffect, useRef, useState } from 'react';
import { MultiplierModel } from '../../../models/multiplier';
import axios from '../../../lib/axios';
import { FIND_OLD_MULTIPLIER, UPDATE_MULTIPLIER } from '../../../lib/endpoints/driverFinancial';
import { useTranslation } from 'react-i18next';

const useChangeMoneyRiderController = () => {
  const [oldMultiplier, setOldMultiplier] = useState<MultiplierModel>(null!);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(null!);

  const { t } = useTranslation('global');

  const baseMoney = useRef<HTMLInputElement>(null!);
  const base0to4 = useRef<HTMLInputElement>(null!);
  const base5toMore = useRef<HTMLInputElement>(null!);
  const percent = useRef<HTMLInputElement>(null!);

  const handleOpenConfirm = (e: any) => {
    e.preventDefault();
    if (handleValidate()) {
      setOpenConfirm(true);
    }
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleValidate = () => {
    if (!/^\d+$/.test(baseMoney.current?.value)) {
      setErrorMessage('Base money must be a valid number.');
      return false;
    }
    if (!/^\d+$/.test(base0to4.current?.value)) {
      setErrorMessage('Base 0-4 km must be a valid number.');
      return false;
    }
    if (!/^\d+$/.test(base5toMore.current?.value)) {
      setErrorMessage('Base 5-more km must be a valid number.');
      return false;
    }
    if (
      percent.current?.value &&
      (isNaN(parseFloat(percent.current.value)) || parseFloat(percent.current.value) > 100)
    ) {
      setErrorMessage('Discount by percent must be a valid number between 0 and 100.');
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleGetData = async () => {
    try {
      await handleGetOldMultiplier();
    } catch (err) {
      // console.log(err);
    }
  };

  const handleGetOldMultiplier = async () => {
    try {
      setLoadingData(true);
      const resData = await axios.get(FIND_OLD_MULTIPLIER);
      const newData: MultiplierModel = resData?.data;
      setOldMultiplier(newData);
      baseMoney.current.value = resData?.data?.baseMoney;
      base0to4.current.value = newData?.baseMoney0to4?.toString();
      base5toMore.current.value = newData?.baseMoney5toEach?.toString();
      percent.current.value = newData?.percent?.toString();
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingData(false);
    }
  };

  const handleUpdateMultiplier = async () => {
    try {
      setLoadingData(true);
      axios.patch(
        `${UPDATE_MULTIPLIER + oldMultiplier?.id}&baseMoney=${baseMoney?.current?.value}&baseM0t4=${
          base0to4?.current?.value
        }&baseM5tE=${base5toMore?.current?.value}&percent=${percent?.current?.value}`
      );
      await handleGetOldMultiplier();
      setOpenConfirm(false);
      window.location.reload();
    } catch (err: any) {
      try {
        const getErrorMessage: any = err.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    oldMultiplier,
    loadingData,
    openConfirm,
    handleCloseConfirm,
    handleOpenConfirm,
    handleUpdateMultiplier,
    errorMessage,
    baseMoney,
    base0to4,
    base5toMore,
    percent,
  };
};
export default useChangeMoneyRiderController;
